import React from 'react';
import { StyledArrow } from '../simple-table.styled';
import { SimpleTableArrowCellProps } from '../simple-table-row/simple-table-row.props';

const ArrowCell = <TRow,>({ column, row }: SimpleTableArrowCellProps<TRow>) => {
  return (
    <StyledArrow justify='center' width={column.width || '100%'}>
      <img src='/assets/images/union.svg' alt='union' />
    </StyledArrow>
  );
};

export default ArrowCell;
